<template>
    <div class="flex w-full border-t-2 border-blue-light sticky bg-white h-32 pin-b shadow-lg rounded-lg">
        <div class="flex-row w-full ml-2">
          <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" :disabled="system.external_data.bios  === false" :class="{'opacity-25': system.external_data.bios != true}" class="flex w-full mb-2">
            <div class="w-1/3 mt-2 text-lg font-bold">Comments</div>
            <div class="mt-2 text-sm cursor-pointer"><button class="underline text-blue" :disabled="system.external_data.bios === false" @click="$emit('open-comment-model')">See all Comments</button></div>
          </div>
          <div class="flex h-full">
            <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" :disabled="system.external_data.bios === false" :class="{'opacity-25': system.external_data.bios != true}"  class="w-4/5 border-r h-1/2 pr-6">
              <div class="resize-none rounded-lg block w-full h-full border ro hover:border-grey focus:border-grey-dark flex">
                <textarea :disabled="system.external_data.bios === false" v-model="body" class="p-2 resize-none rounded-lg block w-5/6 h-full" name="comment" id="comment" cols="30" rows="10" placeholder="Type a comment here..."></textarea>
                <div class="flex items-center justify-end w-1/6 mr-2">
                <button :disabled="system.external_data.bios === false" class="bg-none text-blue rounded border-none" @click="addComment(value)"><icon class="h-18 w-8 text-blue" :center="false" name="plane"></icon></button>
                </div>
              </div>
              <p v-if="commentCheck" class="text-red">Please enter a comment</p>
            </div>
            <div class="flex w-full h-1/2 items-center justify-around">
                <button v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="bg-orange text-white px-6 py-2 rounded hover:bg-orange-dark flex items-center" :disabled="buttons || canCancel" :class="{'opacity-25': buttons === true || canCancel === true}" @click="revertModal = true"><icon :center="false" name="close_small" class="h-6 w-6"></icon>Revert Changes</button>
                <button v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="bg-blue text-white px-6 py-2  rounded hover:bg-blue-dark flex items-center" :disabled="buttons || canCancel" :class="{'opacity-25': buttons === true || canCancel === true }" @click="saveProfile()"><icon name="upload" class="h-6 w-6 mr-2" :center="false"></icon>Save Without Submitting</button>
                <button v-else class="bg-grey text-white px-6 py-2  rounded hover:bg-grey-dark flex items-center mt-12" :disabled="buttons || canCancel" :class="{'opacity-25': buttons === true || canCancel === true}" @click="saveProfile()"><icon name="upload" class="h-6 w-6 mr-2" :center="false"></icon>Save Changes</button>
                <button v-if="value.userApproval.status === 0 && system.external_data.bios === true && system.external_data.reduced_bios === false" :disabled="canCancel" :class="{'opacity-25': canCancel === true}" class="bg-red text-white px-8 py-2  rounded hover:bg-red-dark flex items-center" @click="cancelApproval()"><icon :center="false" name="close_small" class="h-6 w-6"></icon>Cancel Approval</button>
                <button v-else-if="value.userApproval.status === 4 && system.external_data.bios === true && system.external_data.reduced_bios === false" :class="{'opacity-25': canCancel === true }"  class="bg-blue text-white px-8 py-2 rounded hover:bg-blue-dark flex items-center" :disabled="canCancel === true" @click="approveAmends()"><icon name="tick" :center="false" class="w-6 h-6 text-white"/>Approve Amends</button>
                <button v-else-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="bg-green text-white px-8 py-2 rounded hover:bg-green-dark flex items-center" :disabled="buttons" :class="{'opacity-25': buttons === true}" @click="submitApproval()"><icon name="tick" :center="false" class="w-6 h-6 text-white"/>Submit Approval</button>
            </div>
          </div>
        </div>
    <modal
      v-if="revertModal"
      :scrollY="false"
      @dismissed="revertModal = false"
      @leave="revertModal = false"
      :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
    >
      <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <p class="text-center text-lg">Are you sure you want to revert you changes to the live profile</p>
        </div>
        <div class="flex items-center">
          <button  @click="revertChanges()" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Yes
          </button>
          <button  @click="revertModal = false" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            no
          </button>
        </div>
      </div>
    </modal>
    <modal v-if="showSaveProfileModal" :scrollY="false" @dismissed="showSaveProfileModal = false"
      @leave="showSaveProfileModal = false" :showCloseBtn="true"
      :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/4'">
      <h2 class="font-bold text-sm mb-1">Warning!</h2>
      <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <p class="text-center">Please be aware, by selecting this option and saving your profile as a draft, this
            enables you to come back at a later date to edit it and submit for approval. It does not submit your profile
            for approval now.</p>
        </div>
        <div class="flex justify-end w-full">
          <button @click="saveProfile()" class="bg-blue text-white px-6 py-2  rounded hover:bg-blue-dark">
            Proceed & Save as Draft
          </button>
        </div>
      </div>
    </modal>
</div>
</template>

<script>
import api from '@/http'
import { mapActions, mapState } from 'vuex'
import Icon from '../Icon.vue'

export default {
  components: { Icon },
  name: 'approval',
  props: [ 'value' ],
  computed: { ...mapState(['system', 'profile_v2']),
    canCancel () {
      console.log(this.profile_v2.id + ' ' + this.value.userApproval.submitted_by)
      if (this.value.userApproval.submitted_by === null) {
        return false
      }
      if ((this.profile_v2.id !== this.value.userApproval.submitted_by) && (this.value.userApproval.status === 0)) {
        return true
      }
      if (this.profile_v2.id === this.value.userApproval.submitted_by) {
        return false
      }
    }
  },
  data () {
    return {
      revertModal: null,
      body: null,
      commentCheck: null,
      revertLoader: null,
      buttons: true,
      showSaveProfileModal: false
    }
  },
  watch: {
    value: {
      handler () {
        console.log('test')
        if ((this.value.userApproval.status === 0 && this.system.external_data.bios === true)) {
          this.buttons = true
          return
        }
        this.buttons = false
      },
      deep: true
    }
  },
  created () {
    console.log(this.profile_v2.id + ' ' + this.value.userApproval.submitted_by)
    console.log(this.canCancel)
  },

  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    saveProfileModal () {
      this.showSaveProfileModal = true
    },
    saveProfile () {
      console.log('pressing button')
      this.$emit('submitSave')
      this.showSaveProfileModal = false
    },
    submitApproval () {
      console.log('submit')
      this.$emit('submitApproval')
    },
    approveAmends () {
      this.$emit('approveAmends')
    },
    revertChanges () {
      this.$emit('revertChanges')
      this.revertModal = false
    },
    cancelApproval () {
      console.log('cancel')
      this.$emit('cancelApproval')
    },
    addComment (val) {
      this.commentCheck = false
      if (!this.body) {
        this.commentCheck = true
        return
      }
      if (this.body.length === 0) {
        this.commentCheck = true
        return
      }
      let data = {
        body: this.body
      }
      api.post('/add-comment/' + val.id, data).then(
        this.body = ''
      )
    }
  }
}
</script>
